import {
  Edit,
  useNotify,
  useSaveContext,
} from 'react-admin';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import CatalogEditActions from './CatalogEditActions';
import CatalogForm from './CatalogForm';
import { useTitle } from '@src/hooks/useTitle';

const SaveIndicator = () => {
  const { saving } = useSaveContext();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: theme => theme.zIndex.drawer + 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      }}
      open={saving || false}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress color="inherit" size={60} />
        <Typography variant="h6">
          Uploading images and saving changes...
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          This may take a moment for large images
        </Typography>
      </Box>
    </Backdrop>
  );
};

const CatalogItemEdit = () => {
  const { title } = useTitle('Edit Catalog Item');
  const notify = useNotify();

  return (
    <Edit
      mutationMode="pessimistic"
      actions={<CatalogEditActions />}
      title={title}
      mutationOptions={{
        onSuccess: () => {
          notify('Catalog item updated', { type: 'success' });
        },
      }}
      sx={{
        '& .RaEdit-main': {
          marginTop: 0,
        },
        '& .RaEdit-card': {
          marginTop: 0,
        }
      }}
    >
      <CatalogForm />
      <SaveIndicator />
    </Edit>
  );
};

export default CatalogItemEdit;
